export enum AnalyticsEvent {
  TabClicked = 'Tab Clicked',

  // Guest accounts
  UserSignedUp = 'User Signed Up',
  UserConfirmed = 'User Confirmed',
  UserSignedIn = 'User Signed In',

  // Trip Details
  BookAgainClicked = 'Book Again Clicked',
  InfoItemLearnMoreClicked = 'Info Item Learn More Clicked',
  SpiceUpMyStayClicked = 'Spice Up My Stay Clicked',

  // Checkout (reservation)
  GuestCheckedOut = 'Guest Checked Out',
  ScoreSubmitted = 'Score Submitted',

  NpsFeedbackStepEntered = 'NPS Feedback Step Entered',
  NpsFeedbackStepSkipped = 'NPS Feedback Step Skipped',
  NpsFeedbackStepSubmitted = 'NPS Feedback Step Submitted',
  NpsFollowUpStepEntered = 'NPS Follow Up Step Entered',
  NpsBookACallStepEntered = 'NPS Book A Call Step Entered',
  NpsBookACallStepSkipped = 'NPS Book A Call Step Skipped',
  NpsBookACallButtonClicked = 'NPS Book A Call Button Clicked',
  NpsFollowUpStepSkipped = 'NPS Follow Up Step Skipped',
  NpsFollowUpStepSubmitted = 'NPS Follow Up Step Submitted',
  NpsAdditionalFeedbackEntered = 'NPS Additional Feedback Entered',
  NpsAdditionalFeedbackSkipped = 'NPS Additional Feedback Skipped',
  NpsAdditionalFeedbackSubmitted = 'NPS Additional Feedback Submitted',

  AmenityFeedbackSubmitted = 'Amenity Feedback Submitted',
  FeedbackQuestionSubmitted = 'Feedback Question Submitted',
  GoogleReviewLinkViewed = 'Google Review Link Viewed',
  GoogleReviewLinkClicked = 'Google Review Link Clicked',
  NpsFlowCompleted = 'NPS Flow Completed',
  CheckoutCompletedViewed = 'Checkout Completed Viewed',

  TrustPilotLinkViewed = 'Trust Pilot Link Viewed',
  TrustPilotLinkClicked = 'Trust Pilot Link Clicked',

  ReviewLinkViewed = 'Review Link Viewed',
  ReviewLinkClicked = 'Review Link Clicked',

  // Checkout (e-commerce)
  CheckoutStarted = 'Checkout Started',
  CheckoutStepCompleted = 'Checkout Step Completed',
  CheckoutPaymentFailed = 'Checkout Payment Failed',
  CheckoutPaymentSubmit = 'Checkout Payment Submit',
  OrderCompleted = 'Order Completed',
  RefundConfirmed = 'Refund Confirmed',
  CartAbandoned = 'Cart Abandoned',
  PaymentMethodSelected = 'Payment Method Selected',
  PaymentMethodSavedCliked = 'Payment Method Saved Clicked',
  PaymentMethodSavedUncliked = 'Payment Method Saved Unclicked',
  PaymentMethodDeleted = 'Payment Method Deleted',

  // Amend dates
  AmendDatesClicked = 'Amend Dates Clicked',
  AmendDatesSelected = 'Amend Dates Selected',
  AmendDatesOffersViewed = 'Amend Dates Offers Viewed',

  // Amend guests
  AmendGuestsClicked = 'Amend Guests Clicked',
  AmendGuestsSelected = 'Amend Guests Selected',
  AmendGuestsOffersViewed = 'Amend Guests Offers Viewed',

  // Extension
  ExtensionClicked = 'Extension Clicked',
  ExtensionViewed = 'Extension Viewed',
  ExtensionNotAvailable = 'Extension Not Available',

  // Upselling
  ExtraServiceTeaserViewed = 'Extra Service Teaser Viewed',
  ExtraServicesInfoClicked = 'Extra Services Info Clicked',
  ExtraServicesAdded = 'Extra Services Added',

  // Partners
  PartnerClicked = 'Partner Clicked',
  PartnerInfoClicked = 'Partner Info Clicked',

  // Offers
  OfferViewed = 'Offer Viewed',
  // User Interaction
  TripViewed = 'Trip Viewed',

  // Trip Manual Linking
  TripLinked = 'Trip Linked',
  TripLinkingFailed = 'Trip Linking Failed',

  // Onboarding Modal
  OnboardingModalViewed = 'Onboarding Modal Viewed',
  OnboardingModalFinished = 'Onboarding Modal Finished',
  OnboardingModalClosed = 'Onboarding Modal Closed',
  OnboardingStepViewed = 'Onboarding Step Viewed',

  // Install App Banner
  InstallBannerLoaded = 'Install Banner Loaded',
  InstallBannerClosed = 'Install Banner Closed',

  // App Promotion Modal
  AppPromotionModalViewed = 'App Promotion Modal Viewed',
  AppPromotionModalClosed = 'App Promotion Modal Closed',
  AppPromotionModalClicked = 'App Promotion Modal Clicked',

  // Modals in general
  ModalViewed = 'Modal Viewed',
  ModalClosed = 'Modal Closed',

  // Login Prompt
  LoginPromptViewed = 'Login Prompt Viewed',
  LoginPromptClosed = 'Login Prompt Closed',

  // Travel Guide
  TravelGuideViewed = 'Travel Guide Viewed',
  TravelGuideReviewed = 'Travel Guide Reviewed',
  TravelGuideLinkClicked = 'Travel Guide Link Clicked',

  // Member Benefits
  MemberBenefitCardClicked = 'Member Benefit Card Clicked',
  MemberBenefitTeaserViewed = 'Member Benefit Teaser Viewed',

  // Checkout Auth
  CheckoutAuthViewed = 'Checkout Auth Viewed',
  CheckoutAuthFormError = 'Checkout Auth Form Error',
  CheckoutAuthSuccess = 'Checkout Auth Success',

  // Native Signup Modal
  NativeSignupModalViewed = 'Native Signup Modal Viewed',
  NativeSignupModalClosed = 'Native Signup Modal Closed',
  NativeSignupModalClicked = 'Native Signup Modal Clicked',

  // FAQ
  FAQFooterClicked = 'FAQ Footer Clicked',

  // Cancellation
  CancellationOptionsViewed = 'Cancellation Options Viewed',
  CancellationOptionsVoucherClicked = 'Cancellation Options Voucher Clicked',
  CancellationOptionsCancelClicked = 'Cancellation Options Cancel Clicked',
}

export enum CART_CHECKOUT_STEPS {
  PAYMENT = 'PAYMENT',
  CONFIRMATION = 'CONFIRMATION',
}

export enum TRACKING_PAYMENT_METHODS {
  CARD = 'CARD',
  APPLE_PAY = 'APPLE_PAY',
  G_PAY = 'G_PAY',
  KLARNA = 'KLARNA',
  DIRECT_E_BANKING = 'DIRECT_E_BANKING',
  PAYPAL = 'PAYPAL',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TrackingEvent<T = Record<string, any>> = {
  event: AnalyticsEvent;
  properties?: T;
};

export type Integrations = {
  // provider: consent (yes / no)
  [key: string]: boolean;
};
